import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { UserDataContext } from 'context';
import RegistrationFormModel from './Models/registrationFormModel';
import dayjs from 'dayjs';
import ReactToPrint from 'react-to-print';
import QRCode from 'qrcode';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import FooterTailwind from 'TailwindcssComponents/Footer';
import EditRegistrationFormModel from './Models/editRegistrationFormModel';
import AddStageModel from './Models/addStageModel';
import { Icon } from "@iconify/react";
import defaultcover from 'assets/images/logos/defaultcover.png';
import 'react-toastify/dist/ReactToastify.css';
import AddPromotion from './Models/addPromotionModel';
import EditPromotion from './Models/editPromotionModel';
import moment, { isDate } from "moment";
import AddMoreOnEvents from './Models/addMoreOnEventsModel';
import AddSubSection from './Models/addSubSectionModel';
import AddAppMenu from './Models/addAppMenuSectionModel';
import TagsModel from './Models/tagsModel';
import SendEmailModal from './sendEmailModel';

export default function SingleEvent() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const roleId = userData?.isAdmin ? 'admin' : selectedOrganization?.id || null;
    const isDisabled = userRole === 'admin' ? true : false;
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [eventData, setEventData] = useState(null);
    const [openAddFieldDialogBox, setOpenAddFieldDialogBox] = useState();
    const [openEditFieldDialogBox, setOpenEditFieldDialogBox] = useState();
    const [selectedFieldId, setSelectedFieldId] = useState();
    const [openAddStageDialogBox, setOpenAddStageDialogBox] = useState();
    const [openPromotionModel, setOpenPromotionModel] = useState();
    const [openPromotionEditModel, setOpenPromotionEditModel] = useState();
    const [openAddMoreOnEvents, setOpenAddMoreOnEvents] = useState(false);
    const [openAddSubSection, setOpenAddSubSection] = useState(false);
    const [openAddAppSubMenu, setOpenAddAppSubMenu] = useState(false);
    const [openTagsModel, setOpenTagsModel] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedMainCategoryId, setSelectedMainCategoryId] = useState(null);
    const [selectedSubSectionId, setSelectedSubSectionId] = useState(null);
    const [selectedAppSubMenuId, setSelectedAppSubMenuId] = useState(null);
    const [formFieldData, setFormFieldData] = useState([]);
    const [appMenu, setAppMenu] = useState([]);
    const [tagsData, setTagsData] = useState([]);
    const [leadsData, setLeadsData] = useState([]);
    const [stageData, setStageData] = useState([]);
    const [qrCodes, setQrCodes] = useState({});
    const componentRefs = useRef([]);
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [activeTab, setActiveTab] = useState(tagsData?.[0]?.id || null);
    const [selectedTagId, setSelectedTagId] = useState(null);

    const toggleExpand = (id) => {
        setExpandedRowId(prevId => (prevId === id ? null : id));
    };

    const fetchSingleEventData = async () => {
        try {
            setIsLoading(true);
            const responses = await Promise.all([
                axios.get(`${apiUrl}event-service/event/${id}`),
                axios.get(`${apiUrl}event-service/event-zone`, { params: { event: id } }),
                axios.get(`${apiUrl}event-service/ticket-category`, { params: { event: id } }),
            ]);

            const [eventResponse, eventZoneResponse, ticketCategoryResponse] = responses.map(res => res.data);

            if (!eventResponse?.success || !eventResponse?.data) throw new Error('Failed to fetch event');
            if (!eventZoneResponse?.success || !eventZoneResponse?.data) throw new Error('Failed to fetch event zone');
            if (!ticketCategoryResponse?.success || !ticketCategoryResponse?.data) throw new Error('Failed to fetch ticket category');

            const eventZones = eventZoneResponse.data;
            const ticketCategories = ticketCategoryResponse.data;
            const mergedEventZones = eventZones.map(zone => ({
                ...zone,
                ticketCategories: ticketCategories.filter(ticket => ticket.zoneId === zone.id)
            }));

            setEventData({
                ...eventResponse.data,
                eventZones: mergedEventZones,
            });

        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        } finally {
            setIsLoading(false)
        }
    };

    const toggleDescription = () => {
        setShowFullDescription((prev) => !prev);
    };

    // const fetchRegistrationFormField = async () => {
    //     try {
    //         const response = await axios.get(`${apiUrl}event-service/registration-form/${id}`);
    //         if (response.data.success) {
    //             setFormFieldData(data);
    //         }
    //         if (!response.data.success) throw error;
    //     } catch (error) {
    //         console.log(error)
    //     }
    // };

    const defaultFields = [
        { id: 'default-1', name: 'Name', type: 'text', options: '--', formImage: null, isDefault: true },
        { id: 'default-2', name: 'Email', type: 'email', options: '--', formImage: null, isDefault: true },
        { id: 'default-3', name: 'Phone', type: 'phone', options: '--', formImage: null, isDefault: true },
    ];

    const fetchRegistrationFormField = async () => {
        try {
            const response = await axios.get(`${apiUrl}event-service/registration-form`, { params: { event: id } });
            if (response.data?.success && response.data?.data) {
                setFormFieldData([...defaultFields, ...response.data?.data]);
            } else {
                throw new Error("Failed to fetch fields");
            }
        } catch (error) {
            console.log(error.response?.data?.message || error.message);
        }
    };

    const fetchAppMenu = async () => {
        try {
            const responses = await Promise.all([
                axios.get(`${apiUrl}event-service/app-menu`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-event-speaker`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-schedule-category`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-schedule`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-announcement`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-sponsor-category`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-sponsor`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-venue-map`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-exhibitor-category`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
                axios.get(`${apiUrl}event-service/app-exhibitor`, { params: { event: id }, headers: { Authorization: `Bearer ${bearerToken}` } }),
            ])
            const [appMenuResponse, speakersResponse, scheduleCategoryResponse, scheduleResponse, announcementResponse, sponsorCategoryResponse, sponsorsResponse, venueMapsResponse, exhibitorsCategoryResponse, exhibitorsResponse] = responses.map(res => res.data);

            if (!appMenuResponse?.success || !appMenuResponse?.data) throw new Error('Failed to fetch app memu');
            if (!speakersResponse?.success || !speakersResponse?.data) throw new Error('Failed to fetch speakers');
            if (!scheduleCategoryResponse?.success || !scheduleCategoryResponse?.data) throw new Error('Failed to fetch schedule category');
            if (!scheduleResponse?.success || !scheduleResponse?.data) throw new Error('Failed to fetch schedule');
            if (!announcementResponse?.success || !announcementResponse?.data) throw new Error('Failed to fetch announcement');
            if (!sponsorCategoryResponse?.success || !sponsorCategoryResponse?.data) throw new Error('Failed to fetch sponsors category');
            if (!sponsorsResponse?.success || !sponsorsResponse?.data) throw new Error('Failed to fetch sponsors');
            if (!venueMapsResponse?.success || !venueMapsResponse?.data) throw new Error('Failed to fetch venueMaps');
            if (!exhibitorsCategoryResponse?.success || !exhibitorsCategoryResponse?.data) throw new Error('Failed to fetch exhibitors category');
            if (!exhibitorsResponse?.success || !exhibitorsResponse?.data) throw new Error('Failed to fetch exhibitors');
            const appMenuData = appMenuResponse.data;
            const speakers = speakersResponse.data;
            const scheduleCategory = scheduleCategoryResponse.data;
            const schedule = scheduleResponse.data;
            const announcement = announcementResponse.data;
            const sponsorCategory = sponsorCategoryResponse.data;
            const sponsors = sponsorsResponse.data;
            const venueMaps = venueMapsResponse.data;
            const exhibitorCategory = exhibitorsCategoryResponse.data;
            const exhibitors = exhibitorsResponse.data;

            const exhibitorsByCategory = exhibitors.reduce((acc, exhibitor) => {
                const categoryId = exhibitor.appExhibitorCategory.id;
                if (!acc[categoryId]) acc[categoryId] = [];
                acc[categoryId].push(exhibitor);
                return acc;
            }, {});

            const enrichedCategories = exhibitorCategory.map(category => ({
                ...category,
                details: exhibitorsByCategory[category.id] || []
            }));

            const schedulesByCategory = schedule.reduce((acc, schedule) => {
                const categoryId = schedule.category;
                if (!acc[categoryId]) acc[categoryId] = [];
                acc[categoryId].push(schedule);
                return acc;
            }, {});

            const enrichedSchedules = scheduleCategory.map(category => ({
                ...category,
                details: schedulesByCategory[category.id] || []
            }));

            const sponsorsByCategory = sponsors.reduce((acc, schedule) => {
                const categoryId = schedule.category;
                if (!acc[categoryId]) acc[categoryId] = [];
                acc[categoryId].push(schedule);
                return acc;
            }, {});

            const enrichedSponsors = sponsorCategory.map(category => ({
                ...category,
                details: sponsorsByCategory[category.id] || []
            }));

            const typeDataMap = {
                speakers,
                schedule: enrichedSchedules,
                announcement,
                sponsors: enrichedSponsors,
                map: venueMaps,
                exhibitors: enrichedCategories,
            };

            const mergedMenu = appMenuData.map(menuItem => {
                const typeKey = menuItem.type?.toLowerCase();
                return {
                    ...menuItem,
                    typeData: typeDataMap[typeKey] || []
                };
            });
            setAppMenu(mergedMenu);
        } catch (error) {
            console.log(error.response?.data?.message || error.message);
        }
    };

    const fetchStages = async () => {
        try {
            const { data, error } = await supabase.from('stages').select('*').eq('eventId', id);
            if (data) {
                setStageData(data);
            }

            if (error) throw error;
        } catch (error) {
            console.log(error)
        }
    };

    const fetchTags = async () => {
        try {
            const responses = await Promise.all([
                axios.get(`${apiUrl}event-service/event-tag`, { params: { event: id } }),
                axios.get(`${apiUrl}event-service/event-lead`, { params: { event: id } }),
            ])
            const [tagsResponse, leadsResponse] = responses.map(res => res.data);

            if (!tagsResponse?.success || !tagsResponse?.data) throw new Error('Failed to fetch tags');
            if (!leadsResponse?.success || !leadsResponse?.data) throw new Error('Failed to fetch leads');

            setTagsData(tagsResponse.data);
            setLeadsData(leadsResponse.data);

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchSingleEventData();
        fetchRegistrationFormField();
        fetchAppMenu();
        fetchTags();
    }, [id])

    const deleteRow = (id) => {
        deleteRegistrationFormField(id, fetchRegistrationFormField);
    };

    const deleteRegistrationFormField = async (formId, fetchDataCallback) => {
        try {
            const response = await axios.delete(`${apiUrl}event-service/registration-form/${formId}`,
                { headers: { Authorization: `Bearer ${bearerToken}` } }
            );

            if (response.data.success) {
                console.log('Deleted', response.data.message);
            } else {
                console.log('unable to delete');
            }
            fetchDataCallback();
        } catch (error) {
            console.log('Error:', error.response.data.message || error.message);
        }
    };

    const deleteStageRow = (id) => {
        deleteStage(id, fetchStages);
    };

    const deleteStage = async (stageId, fetchDataCallback) => {
        try {
            const response = await supabase.from('stages').delete().eq('id', stageId);
            console.log('Response from Supabase:', response);

            const { data, error } = response;
            if (error) throw error;

            if (data && data.length > 0) {
                console.log('Deleted:', data);
            } else {
                console.log('No data returned, but deletion was successful');
            }
            fetchDataCallback();
        } catch (error) {
            console.log('Error:', error.message);
        }
    };

    const handleAddFieldDialogBox = () => {
        setOpenAddFieldDialogBox(true);
    }

    const handleAddFieldDialogClose = () => {
        setOpenAddFieldDialogBox(false);
        fetchRegistrationFormField();
    };

    const handleEditFieldDialogBox = (fieldId) => {
        setSelectedFieldId(fieldId);
        setOpenEditFieldDialogBox(true);
    }

    const handleEditFieldDialogClose = () => {
        setOpenEditFieldDialogBox(false);
        fetchRegistrationFormField();
    };

    const handleAddMoreOnEventsOpen = (id) => {
        setOpenAddMoreOnEvents(true);
        if (id) {
            setSelectedMainCategoryId(id);
        } else {
            setSelectedMainCategoryId(null);
        }
    }

    const handleAddMoreOnEventsClose = () => {
        setOpenAddMoreOnEvents(false);
        fetchAppMenu();
    };

    const handleAddSubSectionOpen = (name, id) => {
        setOpenAddSubSection(true);
        setSelectedCategory(name.trim().toLowerCase());
        if (id) {
            setSelectedSubSectionId(id);
        } else {
            setSelectedSubSectionId(null);
        }
    }

    const handleAddSubSectionClose = () => {
        setOpenAddSubSection(false);
        fetchAppMenu();
    };

    const handleAddAppSubMenuOpen = (name, menuId, subMenuId) => {
        setOpenAddAppSubMenu(true);
        setSelectedCategory(name.trim().toLowerCase());
        if (subMenuId) {
            setSelectedAppSubMenuId(subMenuId);
        } else {
            setSelectedAppSubMenuId(null);
        }
        if (menuId) {
            setSelectedSubSectionId(menuId);
        } else {
            setSelectedSubSectionId(null);
        }
    }

    const handleAddAppSubMenuClose = () => {
        setOpenAddAppSubMenu(false);
        fetchAppMenu();
    };

    const handleTagsModelOpen = (id) => {
        setOpenTagsModel(true);
        if (id) {
            setSelectedTagId(id);
        } else {
            setSelectedTagId(null);
        }
    }

    const handleTagsModelClose = () => {
        setOpenTagsModel(false);
        fetchTags();
    };

    const handleAddStageDialogBox = () => {
        setOpenAddStageDialogBox(true);
    }

    const handleAddStageDialogClose = () => {
        setOpenAddStageDialogBox(false);
        fetchStages();
    };

    const handlePromotionModelOpen = () => {
        setOpenPromotionModel(true);
    }

    const handlePromotionModelClose = () => {
        setOpenPromotionModel(false);
        fetchSingleEventData();
    };

    const handlePromotionEditModelOpen = () => {
        setOpenPromotionEditModel(true);
    }

    const handlePromotionEditModelClose = () => {
        setOpenPromotionEditModel(false);
        fetchSingleEventData();
    };

    const handleViewForm = () => {
        navigate(`/events/single-event/${id}/view-form`, { state: { formFieldData, id } });
    }

    const handleViewEventRegistrations = () => {
        navigate(`/events/single-event/${id}/view-registrations`);
    }

    const formattedTime = (time) => {
        const [hours, minutes, seconds] = time.split(':');
        const date = new Date();
        date.setHours(hours, minutes, seconds);
        return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    };

    const formattedDate = (date) => {
        return (new Date(date))
            .toUTCString()
            .replace(" GMT", "")  // Remove "GMT"
            .replace(/:\d{2}$/, ""); // Remove seconds
    };

    const generateQRCode = async (stageID, eventID) => {
        try {
            const qrCodeDataUrl = await QRCode.toDataURL(String(`StageID:${stageID} && EventID:${eventID}`));
            setQrCodes((prevState) => ({
                ...prevState,
                [stageID]: qrCodeDataUrl,
            }));
        } catch (error) {
            console.error("Error generating QR code", error);
        }
    };

    const handlePublication = async (eventId, newValue) => {
        setEventData(prevData => ({
            ...prevData,
            status: newValue ? 'published' : 'unpublished',
        }));

        try {
            const endpoint = `${apiUrl}event-service/event/${newValue ? 'publish' : 'unpublish'}/${eventId}`;

            const response = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            if (!response.data.success) {
                throw new Error(response.data.message || `Unable to ${newValue ? 'publish' : 'unpublish'} event`);
            }

            toast.success(response.data.message || `Event ${newValue ? 'Published' : 'Unpublished'}`);
        } catch (error) {
            // Revert state in case of an error
            setEventData(prevData => ({
                ...prevData,
                status: newValue ? 'unpublished' : 'published',
            }));
            toast.error(error.response?.data?.message || error.message);
        }
    };

    const handleRegistration = async (eventId, newValue) => {
        setEventData(prevData => ({ ...prevData, isRegistrationOpen: newValue }));

        try {
            const endpoint = `${apiUrl}event-service/event/${newValue ? 'openRegistration' : 'closeRegistration'}/${eventId}`;
            const { data } = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            toast.success(data.message || `Registration ${newValue ? 'Opened' : 'Closed'}`);
        } catch (error) {
            // Revert state if API fails
            setEventData(prevData => ({ ...prevData, isRegistrationOpen: !newValue }));
            toast.error(`Unable to ${newValue ? 'open' : 'close'} registrations.` || error.response?.data?.message || error.message);
        }
    };

    const handleMobileRegistration = async (eventId, newValue) => {
        setEventData(prevData => ({ ...prevData, isMobileRegistration: newValue }));

        try {
            const endpoint = `${apiUrl}event-service/event/${newValue ? 'open-mobile-registration' : 'close-mobile-registration'}/${eventId}`;
            const { data } = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            toast.success(data.message || `Mobile Registration ${newValue ? 'Opened' : 'Closed'}`);
        } catch (error) {
            // Revert state if API fails
            setEventData(prevData => ({ ...prevData, isRegistrationOpen: !newValue }));
            toast.error(`Unable to ${newValue ? 'open' : 'close'} mobile registrations` || error.response?.data?.message || error.message);
        }
    };

    const handlePromotion = async (eventId, newValue) => {
        setEventData(prevData => ({
            ...prevData,
            promotedEvent: {
                ...prevData.promotedEvent,
                isActive: Boolean(newValue),
            },
        }));

        try {
            const endpoint = `${apiUrl}event-service/promoted-event/${newValue ? 'active' : 'deactive'}/${eventId}`;

            const response = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            if (!response.data.success) {
                throw new Error(response.data.message || `Unable to ${newValue ? 'activate promotion' : 'deactivate promotion'} event`);
            }
            toast.success(response.data.message || `Event ${newValue ? 'promotion activated' : 'promotion deactivated'}`);
        } catch (error) {
            // Revert state in case of an error
            setEventData(prevData => ({
                ...prevData,
                promotedEvent: {
                    ...prevData.promotedEvent,
                    isActive: Boolean(newValue),
                },
            }));
            toast.error(error.response?.data?.message || error.message);
        }
    };

    const handleFeatureEvent = async (eventId, newValue) => {
        setEventData(prevData => ({ ...prevData, isFeaturedEvent: newValue }));

        try {
            const endpoint = `${apiUrl}event-service/event/${newValue ? 'feature' : 'unfeature'}/${eventId}`;
            const { data } = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            toast.success(data.message || `Event ${newValue ? 'featured' : 'unfeatured'} successfully`);
        } catch (error) {
            // Revert state if API fails
            setEventData(prevData => ({ ...prevData, isFeaturedEvent: !newValue }));
            toast.error(`Unable to ${newValue ? 'feature' : 'unfeature'} event.` || error.response?.data?.message || error.message);
        }
    };

    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    const fetchedRegOpenDate = eventData?.registrationOpenDate ? new Date(eventData.registrationOpenDate).toISOString().split('T')[0] : null;
    const isDateGreaterThanCurrent = fetchedRegOpenDate ? new Date(fetchedRegOpenDate) > new Date(currentDate) : false;
    const showOPenRegistrationToggle = isDateGreaterThanCurrent && !(eventData?.isRegistrationOpen);

    const [isOrdering, setIsOrdering] = useState(false);
    const [orderedMenu, setOrderedMenu] = useState(appMenu);
    const [draggedIndex, setDraggedIndex] = useState(null);

    const handleOrderToggle = () => {
        setIsOrdering(!isOrdering);
        setOrderedMenu(appMenu);
    };

    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // Allow dropping
    };

    const handleDrop = (index) => {
        if (draggedIndex === null) return;

        const newOrder = [...orderedMenu];
        const [movedItem] = newOrder.splice(draggedIndex, 1);
        newOrder.splice(index, 0, movedItem);

        setOrderedMenu(newOrder);
        setDraggedIndex(null);
    };

    const handleSaveOrder = async () => {
        const body = {
            menuItems: orderedMenu.map((item, index) => ({
                id: item.id,
                order: index
            })),
            eventId: `${id}`
        };

        try {
            const res = await fetch(`${apiUrl}event-service/app-menu/reorder`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${bearerToken}` },
                body: JSON.stringify(body)
            });

            if (res.ok) {
                toast.success("Order updated successfully!");
                setAppMenu(orderedMenu);
                setIsOrdering(false);
            } else {
                toast.error("Failed to update order");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    const filteredLeads = leadsData?.filter((lead) => lead.tagId === activeTab) || [];

    const handleSendEmails = async ({ tagId, subject, html }) => {
        try {
            setIsLoading(true);
            const formData = new URLSearchParams();
            formData.append("tagId", tagId);
            formData.append("html", html);
            formData.append("subject", subject);
            formData.append("eventId", id);

            const response = await axios.post(
                `${apiUrl}event-service/event-lead/send-email-tag`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                        "Content-Type": "application/x-www-form-urlencoded",
                        accept: "application/json",
                    },
                }
            );

            if (response.data?.success) {
                toast.success("Email sent successfully!");
                setIsModalOpen(false);
            } else {
                toast.error("Failed to send email.");
            }
        } catch (error) {
            console.error("Error sending email:", error.message);
            toast.error("Error sending email.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <TailwindLayout>
            <TopBar />
            {isLoading ? (
                <div className="relative mb-8 p-12 animate-pulse space-y-6">
                    {/* Hero Section Skeleton */}
                    <div className="h-[300px] bg-gray-300 rounded-xl" />

                    {/* Event Card Skeleton */}
                    <div className="bg-white rounded-2xl shadow-xl p-6 space-y-4 -mt-32 mx-4">
                        <div className="flex justify-between items-center border-b pb-4">
                            <div className="h-6 bg-gray-300 w-1/3 rounded" />
                            <div className="h-8 w-20 bg-gray-300 rounded" />
                        </div>

                        {/* Toggles Skeleton */}
                        <div className="flex flex-wrap gap-6 py-4 border-b">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="w-40 h-6 bg-gray-200 rounded" />
                            ))}
                        </div>

                        {/* Date & Contact Info Grid Skeleton */}
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="bg-gray-100 rounded-xl p-4 space-y-3">
                                {[...Array(2)].map((_, i) => (
                                    <div key={i} className="h-4 bg-gray-300 rounded w-3/4" />
                                ))}
                            </div>
                            <div className="bg-gray-100 rounded-xl p-4 space-y-3">
                                {[...Array(2)].map((_, i) => (
                                    <div key={i} className="h-4 bg-gray-300 rounded w-3/4" />
                                ))}
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="bg-gray-100 rounded-xl p-4 mt-6 grid grid-cols-2 gap-6">
                            <div className="h-4 bg-gray-300 rounded w-1/2" />
                            <div className="h-4 bg-gray-300 rounded w-1/2" />
                        </div>

                        {/* Venue and Org Info */}
                        <div className="bg-gray-100 rounded-xl p-4 mt-6 grid grid-cols-2 gap-6">
                            <div className="h-4 bg-gray-300 rounded w-1/2" />
                            <div className="h-4 bg-gray-300 rounded w-1/2" />
                        </div>

                        {/* Description Skeleton */}
                        <div className="bg-gray-100 rounded-xl p-4 mt-6">
                            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2" />
                            <div className="h-3 bg-gray-200 rounded w-full" />
                        </div>

                        {/* Sub-events Table Skeleton */}
                        <div className="bg-white shadow rounded-xl mt-6">
                            <div className="h-10 bg-gray-300 rounded-t-xl" />
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="flex justify-between p-4 border-t">
                                    <div className="h-4 bg-gray-200 rounded w-1/4" />
                                    <div className="h-4 bg-gray-200 rounded w-1/4" />
                                    <div className="h-4 bg-gray-200 rounded w-1/4" />
                                    <div className="h-4 bg-gray-200 rounded w-1/4" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="relative mb-8 p-12">
                    {/* Hero Section with Background Image */}
                    <div
                        className="relative flex items-center min-h-[300px] rounded-xl bg-cover bg-center overflow-hidden"
                        style={{
                            backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.6), rgba(37, 99, 235, 0.6)), url(${eventData?.coverImage?.secure_url || defaultcover})`
                        }}
                    />

                    {eventData && (
                        <>
                            {/* Event Details Card */}
                            <div className="relative -mt-32 mx-4 bg-white rounded-2xl shadow-xl mb-16 overflow-hidden">
                                <div className="p-6 border-b border-gray-100">
                                    <div className="flex flex-row justify-between items-center mb-4">
                                        <h1 className="text-2xl font-semibold">{eventData.name}</h1>
                                        <button
                                            title="Edit Event"
                                            onClick={() => navigate(`/events/edit-event/${id}`)}
                                            className="flex items-center gap-2 p-2 bg-blue-600 rounded-lg hover:bg-blue-300 transition text-white"
                                        >
                                            <Icon icon="iconamoon:edit-thin" className="w-6 h-6 text-white" />
                                        </button>
                                    </div>
                                </div>
                                {/* Toggle Buttons Section */}
                                <div className="px-6 py-4 border-b border-gray-100 bg-gray-50">
                                    <div className="flex flex-wrap items-center gap-6">
                                        <div className="flex items-center gap-1 border-r pr-1">
                                            <span className="text-sm font-medium text-gray-900">Publication Status:</span>
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <span className={`mr-2 text-sm ${eventData.status === 'published' ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                    Unpublished
                                                </span>
                                                <input
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                    checked={eventData.status === "published"}
                                                    onChange={(e) => handlePublication(eventData.id, e.target.checked)}
                                                />
                                                <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                    <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${eventData.status === "published" ? "translate-x-6 border-white" : ""}`} />
                                                </div>
                                                <span className={`ml-2 text-sm ${eventData.status === 'published' ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                    Published
                                                </span>
                                            </label>
                                        </div>

                                        {!showOPenRegistrationToggle && (
                                            <div className="flex items-center gap-1 border-r pr-1">
                                                <span className="text-sm font-medium text-gray-900">Registration Status:</span>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <span className={`mr-2 text-sm ${eventData.isRegistrationOpen ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                        Close
                                                    </span>
                                                    <input
                                                        type="checkbox"
                                                        className="sr-only peer"
                                                        checked={eventData.isRegistrationOpen}
                                                        onChange={(e) => handleRegistration(eventData.id, e.target.checked)}
                                                    />
                                                    <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                        <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${eventData.isRegistrationOpen ? "translate-x-6 border-white" : ""}`} />
                                                    </div>
                                                    <span className={`ml-2 text-sm ${eventData.isRegistrationOpen ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                        Open
                                                    </span>
                                                </label>
                                            </div>
                                        )}

                                        {/* isDisabled is used to check whether admin or not */}

                                        <div className="flex items-center gap-1 border-r pr-1">
                                            <span className="text-sm font-medium text-gray-900">Mobile Registrations :</span>
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <span className={`mr-2 text-sm ${eventData.isMobileRegistration ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                    Close
                                                </span>
                                                <input
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                    checked={eventData.isMobileRegistration}
                                                    onChange={(e) => handleMobileRegistration(eventData.id, e.target.checked)}
                                                />
                                                <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                    <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${eventData.isMobileRegistration ? "translate-x-6 border-white" : ""}`} />
                                                </div>
                                                <span className={`ml-2 text-sm ${eventData.isMobileRegistration ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                    Open
                                                </span>
                                            </label>
                                        </div>

                                        {eventData.featureImage && isDisabled && (
                                            <div className="flex items-center gap-1">
                                                <span className="text-sm font-medium text-gray-900">Feature Event:</span>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <span className={`mr-2 text-sm ${eventData.isFeaturedEvent ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                        No
                                                    </span>
                                                    <input
                                                        type="checkbox"
                                                        className="sr-only peer"
                                                        checked={eventData.isFeaturedEvent}
                                                        onChange={(e) => handleFeatureEvent(eventData.id, e.target.checked)}
                                                    />
                                                    <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                        <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${eventData.isFeaturedEvent ? "translate-x-6 border-white" : ""}`} />
                                                    </div>
                                                    <span className={`ml-2 text-sm ${eventData.isFeaturedEvent ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                        Yes
                                                    </span>
                                                </label>
                                            </div>
                                        )}

                                        {!eventData.promotedEvent && isDisabled && (
                                            <div className="flex items-center gap-1 border-r pr-1">
                                                <span className="text-sm font-medium text-gray-900">Add as Promoted Event</span>
                                                <button
                                                    onClick={() => handlePromotionModelOpen()}
                                                    className="ml-2 px-1 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">
                                                    <Icon icon="material-symbols-light:add" className="text-xl" />
                                                </button>
                                            </div>
                                        )}

                                        {eventData.promotedEvent && isDisabled && (
                                            <div className="flex items-center gap-3 border-r pr-1">
                                                <span className="text-sm font-medium text-gray-900">Promotion Status:</span>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <span className={`mr-2 text-sm ${eventData.promotedEvent?.isActive ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                        Inactive
                                                    </span>
                                                    <input
                                                        type="checkbox"
                                                        className="sr-only peer"
                                                        checked={eventData.promotedEvent?.isActive}
                                                        onChange={(e) => handlePromotion(eventData.promotedEvent?.id, e.target.checked)}
                                                    />
                                                    <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                        <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${eventData.promotedEvent?.isActive ? "translate-x-6 border-white" : ""}`} />
                                                    </div>
                                                    <span className={`ml-2 text-sm ${eventData.promotedEvent?.isActive ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                        Active
                                                    </span>
                                                </label>
                                            </div>
                                        )}

                                        {eventData?.promotedEvent && isDisabled && (
                                            <div className="flex items-center gap-1 border-r pr-1">
                                                <span className="text-sm font-medium text-gray-900">Edit Promoted Event</span>
                                                <button
                                                    onClick={() => handlePromotionEditModelOpen()}
                                                    className="ml-2 px-1 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">
                                                    <Icon icon="material-symbols-light:edit-outline" className="text-xl" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Main Content */}
                                <div className="p-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Date & Time Section */}
                                        <div className="bg-gray-50 rounded-xl p-4">
                                            <div className="space-y-3">
                                                {eventData?.eventDateTimes.map((event, index) => (
                                                    <div key={index} className="flex items-center space-x-2">
                                                        {/* Circle Indicator */}
                                                        <Icon icon="solar:calendar-broken" className="text-md text-gray-500 flex-shrink-0" />

                                                        {/* Date */}
                                                        <div className="flex items-center space-x-2">
                                                            <span className="text-sm text-gray-600 min-w-[130px]">
                                                                {new Date(event.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                                                            </span>

                                                            {/* Vertical Separator */}
                                                            <span className="text-gray-300 self-center">|</span>

                                                            {/* Time */}
                                                            <span className="text-sm text-gray-600">
                                                                {new Date(`1970-01-01T${event.startTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })} -
                                                                {new Date(`1970-01-01T${event.endTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Reg date Section */}
                                        <div className="bg-gray-50 rounded-xl p-4">
                                            <div className="space-y-3">
                                                <div className="flex items-center gap-2">
                                                    <Icon icon="solar:calendar-broken" className="w-4 h-4" />
                                                    {/* <span className="text-sm font-medium text-gray-600">Venue: {eventData.venue?.name}</span> */}
                                                    <span className="text-sm font-medium text-gray-600">Registration Open Date: {formattedDate(eventData.registrationOpenDate)}</span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <Icon icon="solar:calendar-broken" className="w-4 h-4" />
                                                    {/* <span className="text-sm font-medium text-gray-600">Organization: {eventData.organization?.name}</span> */}
                                                    <span className="text-sm font-medium text-gray-600">Registration Close Date: {formattedDate(eventData.registrationCloseDate)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contact Information */}
                                    <div className="mt-6 bg-gray-50 rounded-xl p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-14">
                                            <div className="flex items-center gap-2">
                                                <Icon icon="mdi-light:phone" className="w-4 h-4" />
                                                <span className="text-sm font-medium text-gray-600">{eventData.contactPhone}</span>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <Icon icon="mdi-light:email" className="w-4 h-4" />
                                                <span className="text-sm font-medium text-gray-600">{eventData.contactEmail}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-6 bg-gray-50 rounded-xl p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-14">
                                            <div className="flex items-center gap-2">
                                                <Icon icon="mdi:place-outline" className="w-4 h-4" />
                                                <span className="text-sm font-medium text-gray-600">{eventData.venue?.name}</span>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <Icon icon="octicon:organization-24" className="w-4 h-4" />
                                                <span className="text-sm font-medium text-gray-600">{eventData.organization?.name}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="mt-6 bg-gray-50 rounded-xl p-4">
                                        <div className="flex items-start gap-2">
                                            <svg className="w-5 h-5 text-gray-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                            </svg>
                                            <div>
                                                <span className="text-sm font-medium text-gray-900 block mb-1">Description</span>
                                                <p className="text-sm text-gray-600">
                                                    {eventData.description.length > 50
                                                        ? eventData.description.replace(/<[^>]*>/g, '').substring(0, 50) + '...'
                                                        : eventData.description.replace(/<[^>]*>/g, '')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {eventData.mainEvent && (
                                        <div className="mt-6 bg-gray-50 rounded-xl p-4">
                                            <div className="flex items-start gap-2">
                                                <span className="text-sm font-medium text-gray-900 block mb-1">Main Event: {eventData.mainEvent?.name}</span>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                            {/* sub events */}
                            {eventData?.subEvents?.length > 0 && (
                                <div className="bg-white rounded-xl shadow-lg mb-10">
                                    <div className="mx-4 -mt-6 p-4 bg-blue-600 rounded-xl shadow-lg flex justify-between items-center">
                                        <h2 className="text-lg font-medium text-white">Sub Events</h2>
                                    </div>

                                    <div className="p-4 overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead>
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Contact Phone</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Contact Email</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {eventData?.subEvents?.map((row) => (
                                                    <tr key={row.id} onClick={() => navigate(`/events/view-events/single-event/${row.id}`)} className="cursor-pointer hover:bg-gray-50">
                                                        <td className="px-6 py-4 whitespace-nowrap">{row.name}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">{row.status}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">{row.contactPhone}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">{row.contactEmail}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {/* event zone details */}
                            <div className="bg-white rounded-xl shadow-lg mb-16">
                                <div className="mx-4 -mt-6 p-4 bg-blue-600 rounded-xl shadow-lg flex justify-between items-center">
                                    <h2 className="text-lg font-medium text-white">Event Zones</h2>
                                </div>
                                <div className="p-4 overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead>
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Zone Name</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Capacity</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ticket Category</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Tickets</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Sold Tickets</th>
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            {eventData.zones?.length > 0 ? (
                                                eventData.zones.map((zone, zoneIndex) => {
                                                    const bgClass = zoneIndex % 2 === 0 ? "bg-white" : "bg-gray-100";

                                                    return zone.ticketCategories?.length > 0 ? (
                                                        zone.ticketCategories.map((ticket, index) => (
                                                            <tr key={ticket.id} className={bgClass}>
                                                                {index === 0 && (
                                                                    <>
                                                                        <td className="px-6 py-4" rowSpan={zone.ticketCategories.length}>
                                                                            {zone.name}
                                                                        </td>
                                                                        <td className="px-6 py-4" rowSpan={zone.ticketCategories.length}>
                                                                            {zone.capacity}
                                                                        </td>
                                                                    </>
                                                                )}
                                                                <td className="px-6 py-4">{ticket.name}</td>
                                                                <td className="px-6 py-4">{ticket.totalCount}</td>
                                                                <td className="px-6 py-4">{ticket.soldTickets}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr key={zone.id} className={bgClass}>
                                                            <td className="px-6 py-4">{zone.name}</td>
                                                            <td className="px-6 py-4">{zone.capacity}</td>
                                                            <td className="px-6 py-4 text-gray-500 text-center" colSpan="3">
                                                                No Ticket Categories
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr className="bg-white">
                                                    <td className="px-6 py-4 text-center text-gray-500" colSpan="5">
                                                        No Zones Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                            {/* Form Fields Card */}
                            <div className="bg-white rounded-xl shadow-lg mb-10">
                                <div className="mx-4 -mt-6 p-4 bg-blue-600 rounded-xl shadow-lg flex justify-between items-center">
                                    <h2 className="text-lg font-medium text-white">Form Fields</h2>
                                    {!isDisabled && (
                                        <div className="flex gap-2">
                                            <button
                                                onClick={handleAddFieldDialogBox}
                                                // disabled={isDisabled}
                                                className="p-2 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50"
                                            >
                                                <Icon icon="gala:add" className="w-6 h-6 text-blue-600" />
                                            </button>
                                            <button
                                                onClick={() => (navigate(`/view-eventTickets/detailedView/${id}`))}
                                                className="p-2 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50"
                                            >
                                                <Icon icon="lets-icons:view-light" className="w-6 h-6 text-blue-600" />
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {formFieldData.length > 0 ? (
                                    <div className="p-4 overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead>
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Options</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Images</th>
                                                    {!isDisabled && (
                                                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {formFieldData.map((row) => (
                                                    <tr key={row.id}>
                                                        <td className="px-6 py-4 whitespace-nowrap">{row.name}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">{row.type}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">{row.options || '--'}</td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            {row.formImage?.secure_url ? (
                                                                <img src={row.formImage.secure_url} alt="Form" className="max-h-24 mx-auto" />
                                                            ) : (
                                                                '--'
                                                            )}
                                                        </td>
                                                        {!isDisabled && (
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                {!row.isDefault && (
                                                                    <>
                                                                        <button
                                                                            onClick={() => handleEditFieldDialogBox(row.id)}
                                                                            className="text-blue-600 hover:text-blue-900 mx-2 disabled:opacity-50"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                        <button
                                                                            onClick={() => deleteRow(row.id)}
                                                                            className="text-red-600 hover:text-red-900 mx-2 disabled:opacity-50"
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="py-20 text-center text-gray-500">
                                        No Fields To Show!
                                    </div>
                                )}
                            </div>

                            {/* Other Card */}
                            <div className="bg-white rounded-xl shadow-lg mb-10">
                                <div className="mx-4 -mt-6 p-4 bg-blue-600 rounded-xl shadow-lg flex justify-between items-center">
                                    <h2 className="text-lg font-medium text-white">Mobile App Menu</h2>
                                    {!isDisabled && (
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => handleAddMoreOnEventsOpen(null)}
                                                className="p-2 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50"
                                            >
                                                <Icon icon="gala:add" className="w-6 h-6 text-blue-600" />
                                            </button>
                                            {appMenu.length > 1 && (
                                                <button
                                                    onClick={handleOrderToggle}
                                                    className="p-2 bg-white rounded-full hover:bg-gray-100"
                                                >
                                                    {isOrdering ? "Cancel" : <Icon icon="nrk:reorder" className="w-6 h-6 text-blue-600" />}
                                                </button>
                                            )}

                                        </div>
                                    )}
                                </div>

                                {isOrdering && (
                                    <div className="flex justify-end p-4">
                                        <button
                                            onClick={handleSaveOrder}
                                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                        >
                                            Save Order
                                        </button>
                                    </div>
                                )}

                                {appMenu.length > 0 ? (
                                    <div className="p-4 overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Name
                                                    </th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Icon
                                                    </th>
                                                    {!isDisabled && (
                                                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Actions
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {(isOrdering ? orderedMenu : appMenu).map((row, index) => (
                                                    <React.Fragment key={row.id}>
                                                        <tr
                                                            key={row.id}
                                                            draggable={isOrdering}
                                                            onDragStart={() => handleDragStart(index)}
                                                            onDragOver={handleDragOver}
                                                            onDrop={() => handleDrop(index)}
                                                            className={`hover:bg-gray-50 transition-colors duration-150 ${isOrdering ? "cursor-move bg-gray-50" : ""}`}
                                                        >
                                                            <td className="px-6 py-4 whitespace-nowrap text-left align-middle">
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {row.name}
                                                                </div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-center align-middle">
                                                                <div className="flex justify-center items-center h-12">
                                                                    {row.icon ? (
                                                                        <img
                                                                            src={row.icon?.secure_url}
                                                                            alt="Form Icon"
                                                                            className="h-8 w-8 object-contain rounded"
                                                                        />
                                                                    ) : (
                                                                        <span className="text-gray-400 text-sm">--</span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            {!isDisabled && !isOrdering && (
                                                                <td className="px-6 py-4 whitespace-nowrap text-center align-middle">
                                                                    <div className="flex justify-center items-center space-x-2">
                                                                        <button
                                                                            onClick={() => handleAddSubSectionOpen(row.type)}
                                                                            className="p-1 text-blue-600 hover:text-blue-900 hover:bg-blue-50 rounded transition-colors duration-150 disabled:opacity-50"
                                                                            title="Add Sub Section"
                                                                        >
                                                                            <Icon icon="material-symbols-light:add-rounded" className="w-5 h-5" />
                                                                        </button>
                                                                        <button
                                                                            onClick={() => handleAddMoreOnEventsOpen(row.id)}
                                                                            className="p-1 text-blue-600 hover:text-blue-900 hover:bg-blue-50 rounded transition-colors duration-150 disabled:opacity-50"
                                                                            title="Edit"
                                                                        >
                                                                            <Icon icon="material-symbols-light:edit-outline" className="w-5 h-5" />
                                                                        </button>
                                                                        <button
                                                                            onClick={() => toggleExpand(row.id)}
                                                                            className="p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                                                            aria-expanded={expandedRowId === row.id}
                                                                            aria-controls={`expand-row-${row.id}`}
                                                                            title="Expand/Collapse"
                                                                        >
                                                                            <span className="text-sm font-medium">
                                                                                {expandedRowId === row.id ? <Icon icon="prime:sort-up" className="w-5 h-5" /> : <Icon icon="prime:sort-down" className="w-5 h-5" />}
                                                                            </span>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                        {expandedRowId === row.id && (
                                                            <tr id={`expand-row-${row.id}`} className="bg-gray-50">
                                                                <td colSpan={!isDisabled ? 3 : 2} className="px-6 py-4">
                                                                    {row.typeData && row.typeData.length > 0 ? (
                                                                        row.typeData.map(category => (
                                                                            <details
                                                                                key={category.id}
                                                                                className="border border-gray-200 rounded-lg mb-2 shadow-sm"
                                                                            >
                                                                                <summary className="cursor-pointer px-4 py-2 bg-blue-10 hover:bg-blue-50 text-blue-800 text-sm font-medium flex justify-between items-center">
                                                                                    {category.name}
                                                                                    <div className='flex items-center'>
                                                                                        {(row.type === "exhibitors" || row.type === "schedule" || row.type === "sponsors") && (
                                                                                            <Icon
                                                                                                icon="material-symbols-light:add-rounded"
                                                                                                className="w-4 h-4 ml-2 text-blue-600 hover:text-blue-800"
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    e.stopPropagation();
                                                                                                    handleAddAppSubMenuOpen(row.type, category.id);
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        <Icon
                                                                                            icon="material-symbols-light:edit-outline"
                                                                                            className="w-4 h-4 ml-2 text-blue-600 hover:text-blue-800"
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e.stopPropagation();
                                                                                                handleAddSubSectionOpen(row.type, category.id);
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </summary>
                                                                                {(row.type === "exhibitors" || row.type === "schedule" || row.type === "sponsors") && (
                                                                                    <div className="px-4 py-3 bg-white border-t border-gray-200">
                                                                                        {category.details && category.details.length > 0 && (
                                                                                            <div className="flex flex-wrap gap-2">
                                                                                                {category.details.map(exhibitor => (
                                                                                                    <div
                                                                                                        key={exhibitor.id}
                                                                                                        className="inline-flex items-center px-3 py-1 text-xs font-medium text-blue-800 hover:bg-blue-100 rounded-full border border-blue-200 divide-x divide-gray-300"
                                                                                                    >
                                                                                                        <span className="pr-2">{exhibitor.name}</span>
                                                                                                        <span
                                                                                                            className="pl-2 cursor-pointer"
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handleAddAppSubMenuOpen(row.type, category.id, exhibitor.id);
                                                                                                            }}
                                                                                                        >
                                                                                                            <Icon
                                                                                                                icon="material-symbols-light:edit-outline"
                                                                                                                className="w-3 h-3"
                                                                                                            />
                                                                                                        </span>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </details>
                                                                        ))
                                                                    ) : (
                                                                        <span className="text-xs text-gray-500 italic">
                                                                            No categories available
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="py-20 text-center text-gray-500">
                                        Nothing To Show!
                                    </div>
                                )}
                            </div>

                            {/* tags and leads */}
                            {userRole === 'Stall Manager' && (
                                <div className="bg-white rounded-xl shadow-lg mb-10">
                                    {/* Header */}
                                    <div className="mx-4 -mt-6 p-4 bg-blue-600 rounded-xl shadow-lg flex justify-between items-center">
                                        <h2 className="text-lg font-medium text-white">Tags & Leads</h2>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => handleTagsModelOpen()}
                                                className="p-2 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50"
                                            >
                                                <Icon icon="gala:add" className="w-6 h-6 text-blue-600" />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Tabs */}
                                    <div className="p-4">
                                        <div className="mb-6">
                                            <h3 className="text-md font-medium text-gray-700 mb-2">Tags</h3>
                                            {tagsData && tagsData.length > 0 ? (
                                                <div className="flex border-b border-gray-200">
                                                    {tagsData.map((tag) => (
                                                        <div
                                                            key={tag.id}
                                                            className={`flex items-center px-4 py-2 text-sm font-medium relative group cursor-pointer ${activeTab === tag.id
                                                                ? "border-b-2 border-blue-600 text-blue-600"
                                                                : "border-b-2 border-transparent text-gray-500 hover:text-gray-700"
                                                                }`}
                                                            onClick={() => setActiveTab(tag.id)}
                                                        >
                                                            <span>{tag.name}</span>

                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleTagsModelOpen(tag.id);
                                                                }}
                                                                className="ml-2"
                                                            >
                                                                <Icon icon="mdi:pencil" className="w-4 h-4 text-gray-400 hover:text-gray-600" />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-gray-500">No tags available.</p>
                                            )}
                                        </div>

                                        {/* Leads under active tab */}
                                        <div>
                                            <h3 className="text-md font-medium text-gray-700 mb-2">Leads</h3>
                                            {/* Send Email Button */}
                                            {filteredLeads.length > 0 && (
                                                <button
                                                    onClick={() => setIsModalOpen(true)}
                                                    className="mb-4 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700"
                                                >
                                                    Send Email to All
                                                </button>
                                            )}

                                            {filteredLeads.length > 0 ? (
                                                <div className="flex flex-wrap gap-3">
                                                    {filteredLeads.map((lead) => (
                                                        <div key={lead.id} className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3">
                                                            <div className="text-sm">
                                                                <div className="font-semibold text-gray-800 mb-2">
                                                                    {lead.registration?.name}
                                                                </div>
                                                                <div className="flex flex-col gap-1">
                                                                    <div className="text-xs text-gray-600">
                                                                        {lead.registration?.email}
                                                                    </div>
                                                                    <div className="text-xs text-gray-600">
                                                                        {lead.registration?.phone}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-gray-500">No leads available for this tag.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </>
                    )}
                </div>
            )}

            <RegistrationFormModel
                open={openAddFieldDialogBox}
                onClose={handleAddFieldDialogClose}
                eventId={id}
            />
            <EditRegistrationFormModel
                open={openEditFieldDialogBox}
                onClose={handleEditFieldDialogClose}
                fieldId={selectedFieldId}
                fetchRegistrationFormField={fetchRegistrationFormField}
            />
            <AddMoreOnEvents
                open={openAddMoreOnEvents}
                onClose={handleAddMoreOnEventsClose}
                eventId={id}
                categoryId={selectedMainCategoryId}
            />
            <AddSubSection
                open={openAddSubSection}
                onClose={handleAddSubSectionClose}
                category={selectedCategory}
                eventId={id}
                subId={selectedSubSectionId}
            />
            <AddAppMenu
                open={openAddAppSubMenu}
                onClose={handleAddAppSubMenuClose}
                category={selectedCategory}
                eventId={id}
                subMenuId={selectedAppSubMenuId || null}
                subSectionId={selectedSubSectionId}
            />
            <TagsModel
                open={openTagsModel}
                onClose={handleTagsModelClose}
                eventId={id}
                roleId={roleId}
                tagId={selectedTagId}
            />
            <SendEmailModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSend={handleSendEmails}
                tagId={activeTab}
            />
            <AddStageModel
                open={openAddStageDialogBox}
                onClose={handleAddStageDialogClose}
                eventId={id}
            />
            <AddPromotion
                open={openPromotionModel}
                onClose={handlePromotionModelClose}
                eventId={id}
            />
            <EditPromotion
                open={openPromotionEditModel}
                onClose={handlePromotionEditModelClose}
                eventId={id}
                promotionId={eventData?.promotedEvent?.id}
            />
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}